<template>
  <div style="height: 300px">
    <canvas id="match-chart"></canvas>
  </div>
</template>

<script>
  import Chart from 'chart.js'

  export default {
    props: {
      chartData: {
        type: Object,
        required: true
      }
    },
    data: 
    {
      myChart : null
    },
    watch: {
      chartData (v) {
        this.createChart('match-chart', v)
      }
    },
    methods: {
      createChart(chartId, chartData) {
        var ctx = document.getElementById(chartId);
        if(this.myChart != null)
        {
          this.myChart.destroy();
        }
        this.myChart = new Chart(ctx, {
          type: 'bar',
          data: chartData,
          options: {
            responsive: true,
            scales: {
              xAxes: [{
                gridLines: {
                  drawOnChartArea: false,
                },
              }],
              yAxes: [{
                stacked: true,
                gridLines: {
                  drawOnChartArea: false,
                }
              }]
            },
            legend: {
              display: false,
            },
            maintainAspectRatio: false
          },
        });
      }
    },
    mounted() {
      this.createChart('match-chart', this.chartData)
    }
  }
</script>
